import {
  normalizeUnit,
  isCountUnit,
  isCountRateUnit,
  formatUnitLabel,
} from "../../../utils/payRequestUtils";

const COUNT_UNIT_ALLOWED_RATE_TYPES = ["flat", "step", "cliff"];

// Count units (anything other than hours/days) need the same rate unit, the same unit on
// every tier, and a flat, step or cliff rate type. Same rules as sp_insert/update_contract.
export const getCountUnitContractValidationErrors = (tiers = [], rateType = "") => {
  const errors = {};
  if (!Array.isArray(tiers) || tiers.length === 0) {
    return errors;
  }

  let countUnit = null;

  tiers.forEach((tier, index) => {
    const threshold = normalizeUnit(tier.thresholdUnitType);
    const rateUnit = normalizeUnit(tier.rateUnitType);

    if (isCountUnit(threshold) && !countUnit) {
      countUnit = threshold;
    }

    if (isCountUnit(threshold) && rateUnit !== threshold) {
      const label = formatUnitLabel(threshold);
      errors[`tier_${index}_rateUnitType`] =
        `Rate Unit Type must be ${label} when Threshold Unit Type is ${label}`;
    }
    if (isCountRateUnit(rateUnit) && threshold !== rateUnit) {
      const label = formatUnitLabel(rateUnit);
      errors[`tier_${index}_thresholdUnitType`] =
        `Threshold Unit Type must be ${label} when Rate Unit Type is ${label}`;
    }
  });

  if (!countUnit) {
    return errors;
  }

  const countUnitLabel = formatUnitLabel(countUnit);

  tiers.forEach((tier, index) => {
    if (normalizeUnit(tier.thresholdUnitType) !== countUnit) {
      errors[`tier_${index}_thresholdUnitType`] =
        `All tiers must use ${countUnitLabel} when any tier uses ${countUnitLabel}`;
    }
  });

  if (!COUNT_UNIT_ALLOWED_RATE_TYPES.includes(normalizeUnit(rateType))) {
    errors.rateType = `${countUnitLabel} contracts can only use Flat, Step, or Cliff rate types`;
  }

  return errors;
};
